import { GetOfficerListQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getOfficerList/getOfficerListQuery.type';
import { getOfficerListFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getOfficerList/getOfficerListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getOfficerListQueryOptions = (
  params: GetOfficerListQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['officerList', params],
    queryFn: () => getOfficerListFunction(params),
    enabled: !!params.insurance,
    select: (data) => {
      const newData = {
        code: data.results.map((item) => ({
          label: item.code,
          value: item.name,
        })),
        name: data.results.map((item) => ({
          label: item.name,
          value: +item.code,
        })),
      };
      return newData;
    },
  });
};
